import { getOr } from 'lodash/fp';
import { compose, withProps } from 'recompose';

const withCanCustomerCancel = compose(
  withProps(props => ({
    canCustomerCancel: getOr(false, `${props.selectedLocation}.canCustomerCancel`, props.formValues),
  }))
);

export default withCanCustomerCancel;
